<div class="error_container">
  <div>Icon Goes Here...</div>
  >
  <img class="error_pic" src="../../../../assets/svg/icons/error_page.svg" width="450px" alt="server error" />
  <h2 class="error_message">Oops! We couldn't find the page you were looking for...</h2>
  <h2 class="error_number">ERR 404: Page Not Found</h2>
  <button class="button_main_white" routerLink="/"><i class="material-icons">home</i>BACK TO HOME</button>
</div>
